import { inject } from "@angular/core";
import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { catchError, switchMap, throwError, retry } from "rxjs";
import { AuthService } from "../../features/auth/services/auth.service";
import { AuthResponse } from "../models/auth.reponse";

export const authInterceptorFn: HttpInterceptorFn = (req, next) => {

    const auth = inject(AuthService);

    if (req.url.includes('/token') || req.url.includes('/refreshtoken')) {
        return next(req);
    }

    const authToken = auth.getToken();

    if (!authToken) {
        return next(req);
    }

    const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`)
    });

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if ((error.status === 401 || error.status === 400) && !req.url.includes('/token') && !req.url.includes('/refreshtoken')) {
                const refreshToken = auth.getRefreshToken();
                if (refreshToken) {
                    return auth.refreshToken()
                        .pipe(
                            retry(3),
                            switchMap((response: AuthResponse) => {
                                const retryReq = req.clone({
                                    headers: req.headers.set('Authorization', `Bearer ${response.access_token}`)
                                });
                                auth.setToken(response.access_token);
                                auth.setRefreshToken(response.refresh_token);
                                return next(retryReq);
                            }),
                            catchError((refreshError) => {
                                auth.logout();
                                return throwError(() => refreshError);
                            })
                        );
                }
            }
            return throwError(() => error);
        })
    );
}